__turbopack_context__.v({
  "className": "dancing_script_9b7e63b6-module__h-ixua__className",
});
